import React from "react";
import { useTranslation } from "react-i18next";
import { AppointmentStatusEnum } from "../../../types/appointment.definition";

interface StatusBadgeProps {
  status: string;
  variant?:
    | "neutral"
    | "success"
    | "warning"
    | "error"
    | "primary"
    | "secondary";
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({
  status,
  variant,
}) => {
  const { t } = useTranslation();
  // Get status badge styling
  const getStatusBadgeStyle = (status: string, variant?: string) => {
    // If variant is provided, use it
    if (variant) {
      switch (variant) {
        case "success":
          return "bg-green-100 text-green-800 border border-green-200";
        case "warning":
          return "bg-yellow-100 text-yellow-800 border border-yellow-200";
        case "error":
          return "bg-red-100 text-red-800 border border-red-200";
        case "primary":
          return "bg-blue-100 text-blue-800 border border-blue-200";
        case "secondary":
          return "bg-purple-100 text-purple-800 border border-purple-200";
        case "neutral":
        default:
          return "bg-gray-100 text-gray-800 border border-gray-200";
      }
    }

    // Fallback to appointment status logic
    switch (status) {
      case AppointmentStatusEnum.CONFIRMED:
        return "bg-green-100 text-green-800 border border-green-200";
      case AppointmentStatusEnum.CANCELED:
        return "bg-gray-100 text-gray-800 border border-gray-200";
      case AppointmentStatusEnum.IN_PROGRESS:
        return "bg-blue-100 text-blue-800 border border-blue-200";
      case AppointmentStatusEnum.COMPLETE:
        return "bg-purple-100 text-purple-800 border border-purple-200";
      // Emergency room statuses
      case "available":
        return "bg-green-100 text-green-800 border border-green-200";
      case "occupied":
        return "bg-yellow-100 text-yellow-800 border border-yellow-200";
      case "maintenance":
        return "bg-purple-100 text-purple-800 border border-purple-200";
      case "out_of_service":
        return "bg-red-100 text-red-800 border border-red-200";
      case "reserved":
        return "bg-blue-100 text-blue-800 border border-blue-200";
      default:
        return "bg-gray-100 text-gray-800 border border-gray-200";
    }
  };

  return (
    <span
      className={`px-3 py-1 text-xs font-medium rounded-full ${getStatusBadgeStyle(
        status,
        variant
      )}`}
    >
      {t(`appointment.status.${status}`)}
    </span>
  );
};
